import React, { useEffect, useState } from "react";
import { useAuthBootstrap } from "../../../context/AuthBootstrapContext";
import { useSectionSubmit } from "../lib/useSectionSubmit";
import LabeledInput from "../components/LabeledInput";

const FUN_FACTS = [
  { key: "favorite_book",   label: "Favorite book",           placeholder: "The Fifth Season",  color: "#c2c5d6" },
  { key: "favorite_movie",  label: "Movie I'd watch on repeat", placeholder: "Austin Powers",   color: "#8c7d65" },
  { key: "favorite_artist", label: "An artist I love",        placeholder: "Soccer Mommy",      color: "#b5ad82" },
  { key: "nerd_out_on",     label: "I nerd out on",           placeholder: "Sci-Fi/Fantasy",    color: "#d4a898" },
];

export default function FunFactsSection() {
  const { profileAssets, refreshBootstrap } = useAuthBootstrap();
  const { status, error, submit } = useSectionSubmit({
    endpoint: "/api/settings/fun-facts",
    method: "PATCH",
  });

  const [fields, setFields] = useState({
    favorite_book:   "",
    favorite_movie:  "",
    favorite_artist: "",
    nerd_out_on:     "",
  });

  useEffect(() => {
    if (!profileAssets) return;
    setFields({
      favorite_book:   profileAssets.favorite_book   || "",
      favorite_movie:  profileAssets.favorite_movie  || "",
      favorite_artist: profileAssets.favorite_artist || "",
      nerd_out_on:     profileAssets.nerd_out_on     || "",
    });
  }, [profileAssets]);

  async function onSave(e) {
    e.preventDefault();
    const result = await submit(fields);
    if (result?.ok && typeof refreshBootstrap === "function") {
      await refreshBootstrap();
    }
  }

  return (
    <form onSubmit={onSave} style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <p style={{ margin: 0, fontSize: 14, color: "#888", lineHeight: 1.5 }}>
        Help other creatives get to know you beyond your work. These appear as colored cards on your profile.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        {FUN_FACTS.map(({ key, label, placeholder, color }) => (
          <div key={key}>
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: 4,
                background: color,
                display: "inline-block",
                marginBottom: 6,
                verticalAlign: "middle",
                marginRight: 6,
              }}
            />
            <LabeledInput
              label={label}
              value={fields[key]}
              placeholder={placeholder}
              onChange={(val) => setFields((prev) => ({ ...prev, [key]: val }))}
            />
          </div>
        ))}
      </div>

      {error && (
        <p style={{ margin: 0, fontSize: 13, color: "#b42318" }}>{error}</p>
      )}

      <div>
        <button
          type="submit"
          disabled={status === "saving"}
          style={{
            padding: "10px 24px",
            background: "#17154f",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 600,
            cursor: status === "saving" ? "not-allowed" : "pointer",
            opacity: status === "saving" ? 0.6 : 1,
          }}
        >
          {status === "saving" ? "Saving…" : "Save fun facts"}
        </button>
        {status === "saved" && (
          <span style={{ marginLeft: 12, fontSize: 13, color: "#2d7a4f" }}>Saved ✓</span>
        )}
      </div>
    </form>
  );
}
